import { Box, Text } from '@wix/design-system';
import React from 'react';
import { useCurrentModule } from '../../ModuleProvider';
import { CheckoutDisclaimerLink } from './CheckoutDisclaimerLink';
const URLS = {
  TERMS_OF_USE: 'https://www.wix.com/about/terms-of-use',
  PRIVACY_POLICY: 'https://www.wix.com/about/privacy'
};
export const CheckoutDisclaimer = function (_temp) {
  let {
    isMobile = false
  } = _temp === void 0 ? {} : _temp;
  const currentModule = useCurrentModule();
  const {
    Trans
  } = currentModule.internals.useTranslations();
  return /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(Text, {
    weight: "thin",
    size: "tiny",
    secondary: true
  }, /*#__PURE__*/React.createElement(Trans, {
    i18nKey: "checkout.disclaimer_terms_of_service",
    components: [/*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(CheckoutDisclaimerLink, {
      url: URLS.TERMS_OF_USE,
      isMobile: isMobile
    }), /*#__PURE__*/React.createElement(React.Fragment, null), /*#__PURE__*/React.createElement(CheckoutDisclaimerLink, {
      url: URLS.PRIVACY_POLICY,
      isMobile: isMobile
    })]
  })));
};
//# sourceMappingURL=CheckoutDisclaimer.js.map